module.exports = __webpack_public_path__ + "img/ApprTemp2.00200065.png";